import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getVendors } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import { vendorListCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import Button from 'screens/components/basic/Button';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import WithRouter from 'custom/withRouter';

class VendorList extends Component {
    constructor(props) {
        super(props);

        this.state = { activePage: 1, itemsPerPage: 25 };
    }

    componentWillMount() {
        const s = this.state;
        this.props.init(s.activePage, s.itemsPerPage);
    }

    editVendor = (id) => {
        this.props.navigate(`/vendor/edit/${id}`);
    }

    changePage = e => {
        this.setState({ activePage: e });
        this.props.init(e, this.state.itemsPerPage);
    }

    render() {
        const p = this.props;
        const s = this.state;

        const listVendors = (this.props.vendors || []).map((item) => {
            return {
                id: (<Link className="edit-link" to={`/vendor/edit/${item.id}`}><div style={{ width: '50px' }}>{item.id}</div></Link>),
                name: (<Link to={`/vendor/edit/${item.id}`}>{item.name}</Link>),
                licenseNumber: (item.licenseNumber != null ? item.licenseNumber : "-"),
                category: (item.category != null ? item.category : "-"),
                contact: (item.contact != null ? item.contact : "-"),
                phone: (item.phone != null ? item.phone : "-"),
                email: (item.email != null ? item.email : "-"),
                status: item.status,
                icons: (<div className="row">
                    <div className="btn-group" role="group">
                        <Button
                            type="IconEditButton"
                            mini={true}
                            onTouchTap={() => this.editVendor(item.id)} />
                    </div>
                </div>)
            };
        });

        return (
            <Grid headerContent={vendorListCrumb}>
                <section className="page-top">
                    <div className="page-top-container mb-0">
                        <div className="page-title">
                            <h2>{LOOKUP.vendor.listTitle}</h2>
                        </div>
                        <div className="page-buttons">
                            <Button
                                type="AddButton"
                                mini={true}
                                className="bg-light-green"
                                label={LOOKUP.vendor.controls.addNewButton}
                                onTouchTap={p.callAddVendorForm} />
                        </div>
                    </div>
                </section>
                <CardSimple>
                    <GenericTable
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        stripedRows={true}
                        columns={LOOKUP.vendor.tableColumns}
                        rows={listVendors} />
                    <Pagination
                        rows={listVendors}
                        length={p.vendorsLength || 0}
                        itemsPerPage={s.itemsPerPage}
                        activePage={s.activePage}
                        onPageChange={(e) => this.changePage(e)} />
                </CardSimple>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        vendors: state.entity.vendorList,
        vendorsLength: state.entity.vendorsListLength
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (page, itemsPerPage) => dispatch(getVendors(page, itemsPerPage))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(VendorList));
